"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./css/googlemap.css");
let map;
async function initMap() {
    const center = window.innerWidth > 1080 ? { lat: 50.186, lng: 27.063 } : { lat: 50.186, lng: 27.080 };
    const position = { lat: 50.1907, lng: 27.0810536 };
    const { Map } = await google.maps.importLibrary("maps");
    const { PinView, AdvancedMarkerView } = await google.maps.importLibrary("marker");
    map = new Map(document.getElementById("map"), {
        zoom: 15,
        center: center,
        mapId: "ShepetivkaMebli",
    });
    map.addListener('tilesloaded', () => {
        const el = document.getElementById("map-fallback");
        if (el)
            el.remove();
    });
    const marker = new google.maps.Marker({
        position: position,
        icon: '/images/icons/furniture-store1.png',
        label: {
            color: '#EB5406',
            fontWeight: 'bold',
            fontSize: '16px',
            text: "Дизайн інтер'єр меблі - ДІМ меблів"
        }
    });
    marker.setMap(map);
    const pinViewScaled = new PinView({
        glyphColor: '#FFE87C',
        background: '#4863A0',
        borderColor: '#4863A0',
        scale: 1.5
    });
    new AdvancedMarkerView({
        map: map,
        position: position,
        title: "Дизайн Інтер'єр Меблі Шепетівка - ДІМ меблів",
        content: pinViewScaled.element,
    });
}
initMap();
